import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberBooks } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberBooks } from "@/api/members/books/getAll";
import { useGetMemberBook } from "@/api/members/books/get";

const { getPath } = getApi("members.books.put");

type IExtractedRouteType = IMemberBooks["bookSingleUpdate"];

export type IPutMemberBook = IPickMutation<IExtractedRouteType>;

const putMemberBook: MutationFunction<
  IPutMemberBook["response"],
  IPutMemberBook["variables"]
> = ({ memberId, bookId, ...data }) => {
  return axiosClient.put(getPath({ memberId, bookId }), data);
};

export const usePutMemberBook = createMutation({
  mutationFn: putMemberBook,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberBooks.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberBook.getKey({ memberId }),
    });
  },
});
